import React, { Component, Fragment, createRef } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { CloseOutlined, EyeOutlined, PlusCircleOutlined, InfoCircleOutlined, LoadingOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Dropdown, Spin, Tag, Tooltip, message, Popover, Checkbox, Input, Select } from "antd";
import Table from "@/components/EditableTable";
import {
  addSignal, addPCBInSignals, editSignal, editSignalName, deleteSignal, updateSierraInterface, updateReferenceNets, replaceInterfacePCB,
  updatePcbReplaceInfo, updatePreInfoReplaceInfo, updatePreLayoutReplace, editSignalType, mergeSignalsToSameGroup, updateSignalGroupName,
  saveSignalClock,
  editMasterComp
} from '../../store/sierra/action';
import { refreshPCB } from '../../store/project/action';
import { autoFilterSignalNets, getSignalTypeColor, SIGNAL_TYPE_LIST, I2S_SIGNAL_TYPE_LIST, SIGNAL_CLK, SIGNAL_DATA } from '@/services/Sierra';
import DesignInfo from '@/services/Sierra/pcbInfo';
import { selectChange, changeDisplaySelected, selectLayer, changeShowNameStatus } from '../../../LayoutExplorer/store/Sierra/actionCreators';
import { countTime, closeCountTime } from '@/services/helper/hasOperate';
import projectDesigns from '@/services/helper/projectDesigns';
import canvas from '@/services/LayoutCanvas';
import { NetGroupSelection } from '@/services/PCBHelper';
import { getSelectedDesignIDs } from '@/services/helper/dataProcess';
import PcbReplacePanel from './pcbReplacePanel';
import preLayoutData from '../../../../services/Sierra/prelayout/preLayoutData';
import _ from "lodash";
import { I2S } from '../../../../services/PCBHelper/constants';
import { simulationValueCheck } from '../../../../services/helper/simulationValueCheck';
import { getSignalData, getMasterCompOptions } from '../../../../services/Sierra/helper/signalNetsHelper';
import { settingUnit } from '../../../../services/Sierra';
import '../index.css';
import designConstructor from '../../../../services/helper/designConstructor';

const columns = [
  {
    title: "Signal",
    dataIndex: "name",
    width: "24%"
  },
  {
    title: "PCB",
    dataIndex: "pcb",
    width: "24%"
  },
  {
    title: "Net(s)",
    dataIndex: "nets",
    width: "40%"
  }
];
const groupColumns = [
  {
    title: "Signal",
    dataIndex: "name",
    width: "25%"
  },
  {
    title: "PCB",
    dataIndex: "pcb",
    width: "25%"
  },
  {
    title: "Net(s)",
    dataIndex: "nets",
    width: "30%"
  },
  {
    title: "Group",
    dataIndex: "signalGroup",
    width: "10%"
  },
];

class SignalsNetsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      PCBNets: {},
      pcbReplacePCBName: null,
      replacePcbList: [],
      columns: JSON.parse(JSON.stringify(columns)),
      mergeSignalList: [],
      mergeVisible: false,
      mergeSignalName: null,
      tableHeight: 320,
      hoverSignalName: null,
      clockShow: null,
      clockInput: {},
      mergeError: ""
    }
    this.clockInputRef = createRef();
    this.netGroupSelection = new NetGroupSelection();
  }

  initColumns = () => {
    const showGroup = this.getSignalsClk();
    //has multi clk signals, show group column.
    let _columns = showGroup ? JSON.parse(JSON.stringify(groupColumns)) : JSON.parse(JSON.stringify(columns));

    _columns.forEach(column => {
      switch (column.dataIndex) {
        case "name":
          column.onCell = (record) => {
            let obj = {}
            if (record.signalLength && record.signalLength > 0) {
              obj.rowSpan = record.signalLength;
              obj.tdClassName = 'signalName'
            } else if (!record.pcb) {
              obj.rowSpan = 1;
            } else {
              obj.rowSpan = 0;
            }

            if (!this.props.pcbLoading) {
              const showGroup = this.getSignalsClk();
              return {
                record,
                ...obj,
                edit: true,
                dataIndex: 'name',
                className: 'pintopin-signal-name-cell',
                handleSave: (row) => this.saveSignal(row, record),
                tdClick: (e) => showGroup ? this.tableOnRow(record, e) : null,
                tdClassName: "sierra-signal-td"
              }
            } else {
              return {
                edit: false,
                ...obj
              }
            }
          };
          column.title = () => {
            const iconDisplay = this.getIconDisplay()
            return (
              <div>Signal
                {iconDisplay && <EyeOutlined
                  className="aurora-select-nets-icon"
                  title={'Display all signal nets to layout.'}
                  onClick={() => this.signalsNetSelect(true)} />}
              </div>
            );
          }
          column.render = (value, row, index) => {

            const { type } = row;
            const { mergeVisible, mergeSignalName, hoverSignalName, mergeSignalList, mergeError, clockShow } = this.state;
            const { interfaceType, signals } = this.props;
            const checked = mergeSignalList.includes(row.name);
            const showGroup = this.getSignalsClk();
            const showCheckbox = showGroup && (hoverSignalName === row.name || checked);
            let className = showCheckbox && type ? type === SIGNAL_DATA ? "sierra-signal-name-min-title" : "sierra-signal-name-clk-title" : "sierra-signal-name-plus-title";
            if (showCheckbox && !type) {
              className = "sierra-signal-name-check-title"
            } else if (!showCheckbox && type) {
              className = type === SIGNAL_DATA ? "sierra-signal-name-type-title" : "sierra-signal-name-type-short-title"
            }

            const typeList = interfaceType === I2S ? I2S_SIGNAL_TYPE_LIST : SIGNAL_TYPE_LIST;

            const sameGroups = mergeSignalList.length && mergeSignalName === row.name ? signals.filter(item => mergeSignalList.includes(item.name)).map(item => item.signalGroup) : [];
            const sameGroup = sameGroups.length ? sameGroups.every((item, index, arr) => item === arr[0]) && !!sameGroups[0] : false;
            return <Popover
              placement="topLeft"
              classNames={{
                root: 'merge-part-popover'
              }}
              getPopupContainer={() => document.getElementById(`sierra-signal-row-${row.name}`)
              }
              content={<Fragment>
                <Tooltip title='Merge selected signals into the same group' mouseLeaveDelay={0} mouseEnterDelay={0.3} classNames={{ root: 'icon-tooltip' }}>
                  {!mergeError ? <span className='merge-part-popover-span' onClick={(e) => this.mergeSignal(e, row, sameGroup)}>{sameGroup ? "Un-group" : "Group"}</span> : null}
                  {mergeError ? <span className='merge-part-popover-error-span' >[Group Warning]: {mergeError}</span> : null}
                </Tooltip>
              </Fragment>}
              open={mergeVisible && mergeSignalName === row.name}
            >
              {/* onClick={(e) => { e && e.stopPropagation() }} */}
              {showCheckbox && (
                <Checkbox
                  className='sierra-signal-checkbox'
                  checked={checked}
                  onClick={(e) => this.tableOnRow(row, e, true)}
                />
              )}
              <div id={`sierra-signal-row-${row.name}`} className='sierra-signal-row'>
                <span className={`sierra-signal-name-title ${className}`} title={value}>{value}</span>
                {
                  !this.props.pcbLoading && <CloseOutlined
                    className='signal-delete-icon'
                    onClick={(e) => this.delSignal(e, row, index)} />
                }
                {type === SIGNAL_CLK && showGroup ? this.clockSetup(row, clockShow) : null}
                <Dropdown
                  menu={{
                    items: typeList.map(it => { return { key: it, label: it } }),
                    onClick: (key) => this.signalTypeSelect(key, row)
                  }}>
                  {typeList.includes(type) ? <Tag className="sierra-select-signal-type-icon"
                    title={type}
                    color={getSignalTypeColor(type)}
                    onClick={(e) => { e && e.stopPropagation() }}
                  >{type}</Tag>
                    : <PlusSquareOutlined
                      className="sierra-select-signal-type-icon sierra-select-signal-type-plus-icon"
                      title={'Add signal type'}
                      onClick={(e) => { e && e.stopPropagation() }}
                    />}
                </Dropdown>
                {/*  :
            <Dropdown
              menu={{
                items: signalActions.map(it => { return it.key === "signalType" ? { ...it, children: typeList.map(key => { return { key, label: key } }) } : it }),
                onClick: (key) => this.changeSignalAction(key, row)
              }}>
              <PlusSquareOutlined
                className="sierra-select-signal-type-icon sierra-select-signal-type-plus-icon"
                title={'Add signal type and set clock frequency.'}
                onClick={(e) => { e && e.stopPropagation() }}
              />
            </Dropdown>  */}
              </div >
            </Popover >
          }
          break;
        case "pcb":
          column.onCell = (record) => {
            const _record = { ...record, pcb: record.pcb ? [record.pcb] : [] }
            return {
              record: _record,
              edit: 'select',
              options: this.props.PCBNames,
              dataIndex: "pcb",
              selectMode: 'multiple',
              handleSave: this.addPCBs,
              getPopupContainer: document.getElementById("sierra-content-main"),
              dropdownMenuClassName: 'sierra-select-dropdown-menu',
              getLabel: (option) => this.getLabel(option, record)
            };
          };
          break;
        case "nets":
          column.onCell = (record) => {
            const options = this.getNetsOptions(record);
            return {
              record,
              edit: 'aurora-select',
              editable: true,
              options: options,
              dataIndex: "nets",
              selectMode: 'multiple',
              handleSave: this.netSelection,
              clearSelected: this.clearSelected,
              onChange: this.changeSelected,
              onFocus: () => this.netSelectFocus(record),
              getPopupContainer: document.getElementById("sierra-signal-nets-main-table"),
              dropdownMenuClassName: 'sierra-select-dropdown-menu',
              popupMatchSelectWidth: true
            };
          };
          column.render = (value) => {
            return <span>{value.join(', ')}</span>
          }
          break;
        case "signalGroup":
          column.onCell = (record) => {
            let obj = {}
            if (record.groupLength >= 0) {
              obj.rowSpan = record.groupLength;
            } else {
              obj.rowSpan = 0;
            }

            if (!this.props.pcbLoading && record.signalGroup) {
              return {
                record,
                ...obj,
                edit: true,
                dataIndex: 'signalGroup',
                handleSave: (row) => this.saveGroup(row, record),
                tdClassName: "sierra-signal-group-td"
              }
            } else {
              return {
                edit: false,
                ...obj,
                tdClassName: "sierra-signal-group-td"
              }
            }
          }
          break;
        default:
          break;
      }
    })

    this.setState({
      columns: _columns
    })
  }

  clockSetup = (record, clockShow) => {
    const clockDisplay = record.clock ? `${record.clock}Hz` : "Frequency";
    return <Popover
      key={record.name}
      content={clockShow === record.name ? this.clockContent(record) : null}
      trigger="click"
      onClick={this.inputClick}
      destroyOnHidden={true}
      open={clockShow === record.name ? true : false}
      classNames={{ root: "sierra-signal-clock-popover" }}
    >
      <Tag className="sierra-select-signal-clock-icon"
        title={clockDisplay === "Frequency" ? `Set Clock Frequency` : clockDisplay}
        color={"geekblue"}
        onClick={(e) => { this.openClock(e, record) }}
      >{clockDisplay}</Tag>
    </Popover>
  }

  clearClockInput = () => {
    const { clockInput, clockShow } = this.state;
    this.saveClock(clockInput, { name: clockShow }, true)
    this.setState({
      clockShow: null,
      clockInput: {}
    })
  }

  openClock = (e, record) => {
    this.inputClick(e);
    const clock = settingUnit(record.clock || "", "M");
    this.setState({
      clockShow: record.name,
      clockInput: {
        value: clock.value,
        unit: clock.unit
      }
    }, () => {
      this.clockInputRef && this.clockInputRef.current && this.clockInputRef.current.focus();
    })
  }

  selectClock = (unit, record) => {
    return (
      <Select
        value={unit}
        onChange={(value) => this.clockUnitChange(value, record)}
        popupMatchSelectWidth={false}
        className='sierra-signal-clock-select'
        classNames={{ popup: { root: "sierra-signal-clock-select-popup" } }}
        options={[
          { value: 'K', label: 'KHz' },
          { value: 'M', label: 'MHz' },
          { value: 'G', label: 'GHz' },
        ]}
      />
    )
  }

  clockContent = (record) => {
    const { clockInput } = this.state;
    if (!clockInput) {
      return;
    }
    return (
      <div onClick={this.inputClick}>
        <Input
          key="Clock"
          ref={this.clockInputRef}
          className='sierra-signal-clock-input'
          value={clockInput && clockInput.value ? clockInput.value : ""}
          onChange={e => this.clockChange(e)}
          onKeyDown={e => this.clockKeyDown(e, record)}
          onBlur={(e) => this.saveClock(e, record)}
          addonAfter={this.selectClock(clockInput && clockInput.unit ? clockInput.unit : "M", record)}
        />
        {clockInput.error && <span className='sierra-copy-error' onClick={(e) => this.inputClick(e)}>{clockInput.error}</span>}
      </div>
    );
  }

  clockChange = (e) => {
    e.stopPropagation();
    this.setState({
      clockInput: { ...this.state.clockInput, value: e.target.value, error: "" }
    })
  }

  clockUnitChange = (unit, record) => {
    const { clockInput } = this.state;
    this.setState({
      clockInput: { ...clockInput, unit }
    })
    const error = simulationValueCheck("clock", clockInput.value, unit);
    if (!error) {
      this.props._saveSignalClock(record.name, clockInput.value ? `${clockInput.value}${unit}` : "");
    }
  }

  clockKeyDown = (e) => {
    e.stopPropagation();
    if (e.keyCode === 13) {
      e.target.blur();
    }
  }

  saveClock = (e, record, isClose) => {
    e && e.stopPropagation && e.stopPropagation();
    const { clockInput } = this.state;
    if (!clockInput || Object.keys(clockInput).length === 0) {
      return;
    }
    let value = e && e.target ? e.target.value : "", unit = clockInput.unit;
    if (isClose) {
      value = e.value;
      unit = e.unit || "M";
    }

    const error = simulationValueCheck("clock", value, unit);
    if (value && error) {
      this.setState({
        clockInput: { ...this.state.clockInput, error }
      })
      return
    }

    this.props._saveSignalClock(record.name, value ? `${value}${unit}` : "")
  }

  inputClick = (e) => {
    e && e.stopPropagation();
  }

  getSignalsClk = (_signals) => {
    const { signals } = this.props;
    let _signals_ = _signals || signals || [];
    let existSignals = [], signalTypes = [], signalGroups = [];
    for (let signal of _signals_) {
      if (signal.signalGroup && !signalGroups.includes(signal.signalGroup)) {
        signalGroups.push(signal.signalGroup)
      }
      if (existSignals.includes(signal.name) || signal.type !== SIGNAL_CLK) {
        continue;
      }
      existSignals.push(signal.name)
      signalTypes.push(signal.type)
    }
    return signalGroups.length > 1 || signalTypes.length > 1;
  }

  changeSignalAction = (selected, record) => {
    selected.domEvent && selected.domEvent.stopPropagation();
    this.signalTypeSelect(selected, record)
  }

  signalTypeSelect = (selected, record) => {
    const { key, domEvent } = selected;
    domEvent && domEvent.stopPropagation();
    if (record.type === key || key === "signalType") {
      return;
    }
    this.props._selectSignalType(record.name, key);
  }

  tableOnRow = (record, e, isChecked) => {
    const { name } = record;
    e && e.stopPropagation()
    const parent = document.getElementById(`sierra-signal-row-${name}`);
    if (!isChecked && e && parent && (parent.contains(e.target) || e.target.tagName === 'INPUT' || (e.target.classList && e.target.classList.contains("sierra-signal-name-title")))) {
      return;
    }
    const { mergeSignalList, mergeVisible, mergeSignalName } = this.state;
    let signalList = [...mergeSignalList], visible = mergeVisible;
    if (!mergeSignalList.includes(name)) {
      signalList.push(name);
    } else {
      signalList = signalList.filter(item => item !== name);
    }
    if (signalList.length > 1) {
      visible = true;
    } else {
      visible = false;
    }
    this.setState({
      mergeSignalList: signalList,
      mergeVisible: visible,
      mergeSignalName: mergeSignalName && signalList.includes(mergeSignalName) ? mergeSignalName : record.name
    })
  }

  mergeSignal = (e, record, unGroup) => {
    e.stopPropagation();
    const { mergeSignalList } = this.state;
    if (mergeSignalList.length === 0) {
      return;
    }
    const { signals } = this.props;
    let signalTypes = [];
    for (let name of mergeSignalList) {
      const filterSignals = signals.filter(item => item.name === name);
      signalTypes.push(filterSignals[0].type)
    }

    if (!unGroup) {
      if (signalTypes.filter(item => item === SIGNAL_CLK).length > 1) {
        this.updateMergeError('Only one CLK signal is allowed in a group.')
        return;
      }

      const signalTypeSet = new Set(signalTypes);
      if (signalTypeSet.size === 1 && signalTypeSet.has(SIGNAL_DATA)) {
        this.updateMergeError('A CLK signal is required in a group.')
        return;
      }
    }
    this.props._mergeSignalsToSameGroup({ mergeSignalList, record, unGroup });
    this.setState({
      mergeSignalList: [],
      mergeSignalName: null,
      mergeError: ""
    });
  }

  updateMergeError = (msg) => {
    this.setState({
      mergeError: msg
    });
    setTimeout(() => {
      this.setState({ mergeError: "" })
    }, 2000)
  }

  saveGroup = (row, prevRow) => {
    const { signalGroup } = row;
    const prevGroup = prevRow.signalGroup;
    this.props._updateSignalGroupName(prevGroup, signalGroup);
  }

  uploadReplaceInterfacePcb = (data) => {
    const { newPcbId, oldPcbName, isReplace } = data;
    const { currentProjectId } = this.props;
    const currentProjectPcb = projectDesigns.getAvailableDesigns(currentProjectId);
    const pcbInfo = currentProjectPcb.find(item => item.name === oldPcbName);
    if (pcbInfo && pcbInfo.id && newPcbId) {
      this.props._replaceInterfacePCB(pcbInfo.id, newPcbId, isReplace)
    }
  }

  pcbReplaceClick = (e, option, record) => {
    e && e.stopPropagation && e.stopPropagation();

    // get can replaced pcbId
    const { PCBNames, signals, currentProjectId } = this.props;
    const oldPCBName = record.pcb;
    let signalsMap = {}, filterPCBNames = [oldPCBName]
    signals.forEach(item => {
      signalsMap[item.name] = signalsMap[item.name] || [];
      signalsMap[item.name].push(item.pcb);
    });
    let filterSignalNames = signalsMap ? Object.keys(signalsMap) : []
    filterSignalNames.forEach(item => {
      if (signalsMap[item] && signalsMap[item].includes(oldPCBName) && signalsMap[item].length > 1) {
        filterPCBNames.push(...signalsMap[item].filter(info => info !== oldPCBName))
      }
    })
    const _PCBNames = PCBNames.filter(item => !filterPCBNames.includes(item));
    const pcbInfo = projectDesigns.getAvailableDesigns(currentProjectId).filter(item => _PCBNames.includes(item.name)).map(item => { return { id: item.id, name: item.name } });
    this.props._updatePcbReplaceInfo({ panelVisible: true, pcbReplacedName: option, replacePcbList: pcbInfo })
    if (_PCBNames.length) {
      this.setState({
        pcbReplacePCBName: option,
        replacePcbList: pcbInfo
      })
    }
  }

  getPcbReplace = (pcbName) => {
    this.props._updatePcbReplaceInfo()
    this.setState({
      pcbReplacePCBName: pcbName
    })
  }

  getLabel = (option, record) => {
    const isPreLayout = this.props.preLayoutReady.includes(record.pcbId);
    return <Fragment>
      <span className='sierra-signal-pcb-title'>{option}</span>
      {!isPreLayout && <span onClick={(e) => this.pcbReplaceClick(e, option, record)} className={`iconfont icon-replace1 aurora-option-label-icon`}></span>}
    </Fragment>
  }

  delSignal = (e, row, index) => {
    e && e.stopPropagation && e.stopPropagation();
    this.props.deleteSignal({ name: row.name });
    if (row.nets && row.nets.length > 0) {
      countTime(this.gerRefNets, 10000);
    }
  }

  getIconDisplay = () => {
    const { Interfaces, selectedDesignIDs } = this.props;
    const pcbList = Interfaces.map(item => item.pcbId)
    const filterIds = pcbList.filter(item => selectedDesignIDs.includes(item))
    if (filterIds.length) { return true }
    return false
  }

  selectDisplay = (nets, pcbId) => {
    const { selectedDesignIDs } = this.props;
    if (selectedDesignIDs.includes(pcbId)) {
      this.props._selectChange({ nets: [...nets] }, pcbId);
      this.props.changeDisplaySelected(true, pcbId)
    }
  }

  clearSelected = (value, record, setFieldsValue) => {
    const { nets, pcbId, name } = record;
    const newNets = nets.filter(item => item !== value);
    this.props.editSignal({ nets: [...newNets], pcbId, signalName: name });
    if (setFieldsValue) {
      setFieldsValue({ nets: newNets })
    }
    this.selectDisplay([...newNets], pcbId);
  }

  changeSelected = (list, record, setFieldsValue) => {
    const { nets, pcbId, name } = record;
    let newNets = [...nets];
    if (!list) {
      return;
    }
    if (list.length === 1 && nets.includes(list[0])) {
      newNets = newNets.filter(item => item !== list[0]);
    } else {
      newNets = [...new Set([...newNets, ...list])];
    }
    this.props.editSignal({ nets: [...newNets], pcbId, signalName: name });
    if (setFieldsValue) {
      setFieldsValue({ nets: newNets })
    }
    this.selectDisplay([...newNets], pcbId);
  }

  getSelectData = (record) => {
    const { Interfaces } = this.props;
    const { pcbId, nets } = record;
    const currentInterface = Interfaces.find(item => item.pcbId === pcbId);
    let pinsObj = {}, comps = [], resComp = [];
    const { components = [], port_setups = [] } = currentInterface.content;
    for (let port_setup of port_setups) {
      const { info, positive } = port_setup;
      if (nets.includes(info.net)) {
        if (!pinsObj[positive.component]) {
          // add components
          comps.push(positive.component)
          pinsObj[positive.component] = []
        }
        pinsObj[positive.component].push(positive.pin)
      }
    }


    for (let comp of components) {
      const { type, pins, name } = comp
      if (['Res', 'Jumper'].includes(type)) {
        const filterNets = pins.filter(item => nets.includes(item.net))
        if (filterNets.length) {
          // add connect select signal net res comp
          comps.push(name);
          resComp.push(name)
        }

        const filterPin = pins.filter(item => nets.includes(item.net));
        if (filterPin && filterPin.length && pins.length > 2) {
          pinsObj[name] = filterPin.map(item => item.pin)
        }
      } else if (type === 'Repeater') {
        const filterPin = pins.filter(item => nets.includes(item.net));
        if (filterPin) {
          pinsObj[name] = filterPin.map(item => item.pin)
          comps.push(name)
        }
      }
    }
    comps = [...new Set(comps)];
    const layout = canvas.getLayout(pcbId);
    let layers = layout && layout.findCurrentLayer ? layout.findCurrentLayer(comps) : [];
    layers = [...new Set(layers)];
    // get layers
    return { pinsObj, comps, layers, resComp }
  }

  signalsNetSelect = () => {
    const { Interfaces, selectedDesignIDs } = this.props;
    const interfaces = Interfaces.filter(i => selectedDesignIDs.includes(i.pcbId));
    if (!interfaces.length) return;
    interfaces.forEach(d => {
      const pcbId = d.pcbId;
      let _signalNets = [];
      for (let signal of d.content.signals) {
        _signalNets = [..._signalNets, ...signal.nets]
      }
      const { pinsObj, comps, layers, resComp } = this.getSelectData({ pcbId, nets: _signalNets })
      this.props._selectLayer(layers, pcbId);
      this.props._selectChange({ pinsObj, comps, nets: [..._signalNets] }, pcbId);
      this.props.changeDisplaySelected(true, pcbId)
      this.props._changeShowNameStatus(true, pcbId)
      setTimeout(() => {
        this.netGroupSelection.selectNetGroup({ pinsObj, comps, nets: [..._signalNets], pcbId, resComp })
      }, 800);
    })
  }

  netSelectFocus = (record) => {
    const { pcbId, nets } = record;
    const { selectedDesignIDs } = this.props;
    if (selectedDesignIDs.includes(pcbId)) {
      if (nets.length) {
        const { pinsObj, comps, layers, resComp } = this.getSelectData(record)
        this.props._selectLayer(layers, pcbId);
        this.props._selectChange({ pinsObj, comps, nets: [...nets] }, pcbId);
        setTimeout(() => {
          this.netGroupSelection.selectNetGroup({ pinsObj, comps, nets: [...nets], pcbId, resComp })
        }, 800);
      } else {
        this.props._selectChange({ nets: [...nets] }, pcbId);
      }
      this.props.changeDisplaySelected(true, pcbId)
      this.props._changeShowNameStatus(true, pcbId)
    }
  }

  netSelection = (record) => {
    const { nets, pcbId } = record;
    const options = this.getNetsOptions(record);
    const newNets = nets.filter(item => options.includes(item));
    this.selectDisplay([...newNets], pcbId);
    countTime(this.gerRefNets, 10000);
  }

  getNetsOptions = (record) => {
    const { PCBNets } = this.state;
    return PCBNets[record.pcbId] || [];
  }

  addPCBs = (record) => {
    const { pcb, name, pcbId, nets, type, signalGroup } = record;
    this.props.addPCBInSignals({ pcbs: pcb, name, pcbId, signalType: type, signalGroup });
    if (nets && nets.length > 0) {
      countTime(this.gerRefNets, 10000);
    }
  }

  addSignal = (e) => {
    const { PCBNames } = this.props;
    let addPcbName = null;
    if (PCBNames && PCBNames.length === 1) {
      //If there is only one pcb, add it automatically
      addPcbName = PCBNames[0];
    }
    this.props.addSignal(addPcbName);
    //The table has a scroll bar to scroll to the bottom
    setTimeout(() => {
      const table = ReactDOM.findDOMNode(this.table),
        tableBody = table ? table.querySelector('.aurora-table-body') : null;
      if (tableBody && tableBody.scrollHeight) {
        tableBody.scrollTop = tableBody.scrollHeight;
      }
    }, 240);
  }

  saveSignal = (row, prev) => {
    const prevName = prev.name;
    const name = row.name;
    const { signals } = this.props;
    const { mergeSignalList, mergeSignalName } = this.state;
    let newSignals = [...signals];
    if (!row.pcb) {
      let reName = newSignals.find(item => item.name !== prevName && item.name === name);
      if (reName) {
        message.error('Signal name cannot be repeated.');
        return;
      }
      newSignals.forEach(item => {
        if (item.name === prevName) {
          item.name = name;
        }
      });

      this.props.updateSierraInterface({ signals: JSON.parse(JSON.stringify(newSignals)) });
      return;
    }
    this.props.editSignalName(name, prevName);

    let _mergeSignalList = [...(mergeSignalList || [])], _mergeSignalName = mergeSignalName;
    if (prevName && _mergeSignalList.includes(prevName)) {
      _mergeSignalList = _mergeSignalList.filter(item => item !== prevName);
      _mergeSignalList.push(name);
    }
    if (mergeSignalName && mergeSignalName === prevName) {
      _mergeSignalName = name;
    }
    this.setState({
      mergeSignalList: _mergeSignalList,
      mergeSignalName: _mergeSignalName
    })
  }

  gerRefNets = () => {
    this.props._updateReferenceNets();
  }

  componentDidMount() {
    this.getPcbNets();
    this.initColumns()
    window.addEventListener('resize', this.calcScrollHeight);
    this.calcScrollHeight()
    document.addEventListener('mousedown', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calcScrollHeight);
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  }

  componentDidUpdate(prevProps) {
    this.getPcbNets(prevProps);
    const { verificationId, signals } = this.props;
    const interfaceUpdate = verificationId !== prevProps.verificationId
    if (interfaceUpdate) {
      //clear count update reference nets time
      closeCountTime();
      this.calcScrollHeight()
    }

    if (interfaceUpdate || signals.length !== prevProps.signals.length || !_.isEqual(signals || [], prevProps.signals || [])) {
      const showGroup = this.getSignalsClk();
      const prevShowGroup = this.getSignalsClk(prevProps.signals);
      this.setState({
        mergeSignalList: [],
        mergeVisible: false,
        mergeSignalName: ""
      })
      if (showGroup !== prevShowGroup) {
        this.initColumns()
      }
    }

    if ((!prevProps.signals && signals && signals.length)
      || (prevProps.signals && signals && prevProps.signals.length !== signals.length)
      || (prevProps.signals && signals && !_.isEqual(signals, prevProps.signals))) {
      this.calcScrollHeight()
    }
  }

  handleClickOutside = (e) => {
    const { target } = e;
    const PopoverRoot = document.getElementsByClassName('sierra-signal-clock-popover')[0];

    if (!PopoverRoot) {
      return;
    }

    const selectEle = document.getElementsByClassName('sierra-signal-clock-select-popup')[0];
    if (PopoverRoot && !PopoverRoot.contains(target) && !(selectEle && selectEle.contains(target))) {
      this.clearClockInput();
    }
  }

  calcScrollHeight = () => {
    setTimeout(() => {
      const table = ReactDOM.findDOMNode(this.table),
        tableBody = table ? table.querySelector('.ant-table-tbody') : null;
      this.setState({
        tableHeight: tableBody && tableBody.scrollHeight ? tableBody.scrollHeight : 320
      })
    }, 240);
  }

  getPcbNets = (prevProps) => {
    const { currentPCBs, pcbComponentsNets, refreshStatus, preLayoutReady } = this.props;
    const { PCBNets } = this.state;
    currentPCBs.forEach(pcbId => {
      if ((!PCBNets[pcbId] || (refreshStatus && prevProps && refreshStatus !== prevProps.refreshStatus))) {
        if (preLayoutReady.includes(pcbId)) {
          const nets = preLayoutData.getNets(pcbId);
          this.setState((prevState) => {
            prevState.PCBNets[pcbId] = nets;
            return {
              PCBNets: prevState.PCBNets
            }
          });
        } else if (pcbComponentsNets.includes(pcbId)) {
          const info = DesignInfo.getPCBInfo(pcbId);
          if (info && info.netsList) {
            const netsList = DesignInfo[pcbId].netsList;
            const filter = autoFilterSignalNets(netsList);
            this.setState((prevState) => {
              prevState.PCBNets[pcbId] = filter;
              return {
                PCBNets: prevState.PCBNets
              }
            });
          }
        }
      }
    });

    if (prevProps && refreshStatus && refreshStatus !== prevProps.refreshStatus) {
      this.props.refreshPCB(false);
    }
  }

  replacePreClick = () => {
    const { preLayoutReplaceInfo } = this.props;
    this.props._updatePreLayoutReplace(preLayoutReplaceInfo.map(item => item.pcbId))
  }

  cancelPreReplace = () => {
    this.props._updatePreInfoReplaceInfo(null)
  }

  getPreReplaceLog = (preLayoutReplaceInfo) => {
    return <div className="sierra-pcb-replace-msg-box">
      {preLayoutReplaceInfo.length && preLayoutReplaceInfo.map((item) => {
        if (!item.updateInfo) {
          return null;
        }
        return <Fragment key={item.pcbId}>
          <div className="pcb-replace-msg">[Warning] The pre-layout {item.pcbName} has been updated: </div>
          {item.updateInfo.delNets && item.updateInfo.delNets.length > 0 && <Fragment>
            <div className="pcb-replace-msg">[Warning] The pre-layout does not have the following nets: </div>
            <div className="pcb-replace-previewInfo">{item.updateInfo.delNets.join(', ')}</div></Fragment>}
          {item.updateInfo.delCompPins && item.updateInfo.delCompPins.length > 0 && <Fragment>
            <div className="pcb-replace-msg">[Warning] The pre-layout does not have the following component-pins: </div>
            <div className="pcb-replace-previewInfo">[{item.updateInfo.delCompPins.map(it => `${it.component}-${it.pin}`).join(', ')}]</div></Fragment>}
          {item.updateInfo.addCompPins && item.updateInfo.addCompPins.length > 0 && <Fragment>
            <div className="pcb-replace-msg">[Warning] The pre-layout adds new component-pins connected to signal nets: </div>
            <div className="pcb-replace-previewInfo">[{item.updateInfo.addCompPins.map(it => `${it.component}-${it.pin}`).join(', ')}]</div></Fragment>}
        </Fragment>
      })}
      <div className="pcb-replace-button-box">
        <Button
          onClick={this.replacePreClick}
          type="primary"
          title={"Update interface by pre-layout setup."}
        >Update</Button>
        <Button
          onClick={this.cancelPreReplace}
        >Cancel</Button>
      </div>
    </div>
  }

  setHoveredRowKey = (signalName) => {
    /*    const { hoverSignalNames } = this.state;
       let _hoverSignalNames = [...(hoverSignalNames || [])];
       if (_hoverSignalNames.includes(signalName)) {
         _hoverSignalNames = _hoverSignalNames.filter(name => name !== signalName);
       } else {
         _hoverSignalNames.push(signalName)
       } */
    this.setState({
      hoverSignalName: signalName
    })
  }

  render() {
    const { currentProjectId, pcbReplaceInfo, currInterfaceDesignMessage, preLayoutReplaceInfo, signals } = this.props;
    const { loading, pcbReplacePCBName, replacePcbList, columns, mergeSignalList, tableHeight } = this.state;
    const data = getSignalData(signals);
    return (
      <Spin spinning={loading}>
        <span className="font-bold sierra-setup-title-color">Signal Nets</span>
        <PlusCircleOutlined className='signal-add-icon' onClick={this.addSignal} />
        {currInterfaceDesignMessage ? <Tooltip
          title={currInterfaceDesignMessage}
        >
          <InfoCircleOutlined className='signal-interface-design-info-icon' />
        </Tooltip> : null}
        {!currInterfaceDesignMessage && preLayoutReplaceInfo && preLayoutReplaceInfo.length ? <Tooltip
          trigger={['click']}
          title={preLayoutReplaceInfo && preLayoutReplaceInfo[0] && preLayoutReplaceInfo[0].loading ? "Updating pre-layout interface..." : this.getPreReplaceLog(preLayoutReplaceInfo)}
          classNames={{ root: 'sierra-replace-tooltip' }}
        >
          {preLayoutReplaceInfo && preLayoutReplaceInfo[0] && preLayoutReplaceInfo[0].loading ? <LoadingOutlined className='signal-interface-design-loading-info-icon' /> : <InfoCircleOutlined className='signal-interface-design-info-icon' />}
        </Tooltip> : null}
        <Table
          ref={(ref) => this.table = ref}
          columns={columns}
          className="sierra-signal-nets-table"
          id="sierra-signal-nets-main-table"
          dataSource={data}
          rowKey={record => record.name + '_' + record.pcb}
          expandIconAsCell={false}
          scroll={{ y: tableHeight >= 320 ? 320 : undefined }}
          onRow={record => {
            let rowClassName = '';
            if (mergeSignalList.length > 0 && mergeSignalList.includes(record.name)) {
              rowClassName = 'sierra-signal-select-row'
            }
            return {
              className: rowClassName,
              onMouseEnter: () => this.setHoveredRowKey(record.name),
              onMouseLeave: () => this.setHoveredRowKey(null),
            };
          }}
          tableLayout="fixed"
        />
        {pcbReplaceInfo && pcbReplaceInfo.panelVisible ?
          <PcbReplacePanel
            pcbName={pcbReplacePCBName}
            getPcbReplace={this.getPcbReplace}
            replacePcbList={replacePcbList}
            currentProjectId={currentProjectId}
            uploadReplaceInterfacePcb={this.uploadReplaceInterfacePcb}
            updatePcbReplaceInfo={this.props._updatePcbReplaceInfo}
            pcbReplaceInfo={pcbReplaceInfo}
          /> : null}
      </Spin>
    );
  }
}

const mapState = (state) => {
  const { SierraReducer: { sierra, project: { pcbComponentsNets, currentProjectId, viewList, refreshStatus, verificationId, selectedKeys, preLayoutReady = [], currentProjectVerifications } } } = state;
  const sierraInfo = sierra.sierraInfo;
  let signals = [], currentPCBs = [], Interfaces = [];
  if (sierraInfo) {
    signals = JSON.parse(JSON.stringify(sierraInfo.info ? sierraInfo.info.signals || [] : []));
    currentPCBs = (sierraInfo.Interfaces || []).map(item => item.pcbId);
    Interfaces = (sierraInfo.Interfaces || []);
  }
  const PCBNames = projectDesigns.getAvailableDesigns(currentProjectId).map(item => item.name);
  let interfaceInfo = currentProjectVerifications.find(item => item.id === verificationId);
  let interfaceType = interfaceInfo ? interfaceInfo.type : ''
  return {
    signals,
    PCBNames,
    pcbComponentsNets,
    currentPCBs,
    viewList,
    refreshStatus,
    verificationId,
    pcbLoading: sierra.pcbLoading,
    Interfaces,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    currentProjectId,
    pcbReplaceInfo: sierra.pcbReplaceInfo,
    preLayoutReady,
    currInterfaceDesignMessage: sierra.currInterfaceDesignMessage,
    preLayoutReplaceInfo: sierra.preLayoutReplaceInfo,
    interfaceType
  }
};

const mapDispatch = (dispatch) => ({
  addSignal(addPcbName) {
    dispatch(addSignal(addPcbName));
  },
  addPCBInSignals(info) {
    dispatch(addPCBInSignals(info))
  },
  editSignal({ nets, pcbId, signalName }) {
    dispatch(editSignal({ nets, pcbId, signalName }));
  },
  editSignalName(name, prevName) {
    dispatch(editSignalName(name, prevName));
  },
  deleteSignal({ name }) {
    dispatch(deleteSignal({ name }))
  },
  updateSierraInterface(data) {
    dispatch(updateSierraInterface(data))
  },
  _selectChange(obj = {}, designID) {
    dispatch(selectChange(obj, designID))
  },
  changeDisplaySelected(show, designID) {
    dispatch(changeDisplaySelected(show, designID))
  },
  refreshPCB(refreshStatus) {
    dispatch(refreshPCB(refreshStatus))
  },
  _updateReferenceNets() {
    dispatch(updateReferenceNets())
  },
  _selectLayer(layers, designID) {
    dispatch(selectLayer(layers, designID))
  },
  _changeShowNameStatus(status, designID) {
    dispatch(changeShowNameStatus(status, designID))
  },
  _replaceInterfacePCB(previousPCBId, newPCBId, isReplace) {
    dispatch(replaceInterfacePCB(previousPCBId, newPCBId, isReplace))
  },
  _updatePcbReplaceInfo(info) {
    dispatch(updatePcbReplaceInfo(info))
  },
  _updatePreInfoReplaceInfo(info) {
    dispatch(updatePreInfoReplaceInfo(info))
  },
  _updatePreLayoutReplace(pcbIds) {
    dispatch(updatePreLayoutReplace(pcbIds))
  },
  _selectSignalType(signalName, signalType) {
    dispatch(editSignalType(signalName, signalType))
  },
  _mergeSignalsToSameGroup({ mergeSignalList, record, unGroup }) {
    dispatch(mergeSignalsToSameGroup({ mergeSignalList, record, unGroup }))
  },
  _updateSignalGroupName(prevGroup, newGroup) {
    dispatch(updateSignalGroupName(prevGroup, newGroup))
  },
  _saveSignalClock(signalName, clock) {
    dispatch(saveSignalClock(signalName, clock))
  }
})

export default connect(mapState, mapDispatch)(SignalsNetsTable);